import React, { Component } from 'react';
import { Popover } from 'reactstrap';
import { CirclePicker, SketchPicker } from 'react-color';

export class SimpleColorPicker extends Component {

  state = {
    popover: false
  };

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.renderValue = this.renderValue.bind(this);
  }

  toggle() {
    this.setState({
      popover: !this.state.popover
    });
  }

  renderValue() {
    if (this.props.iconOnly) {
      return null;
    }

    return this.props.value;
  }

  render() {
    return (
      <div className={"t-generic-color-picker " + (this.props.iconOnly ? 'icon-only' : '')}>
        <button id={this.props.name} className="btn btn-block" onClick={this.toggle}>
          <span className="color-sample" style={{backgroundColor: this.props.value}} />
          {this.renderValue()}
        </button>
        <Popover placement="bottom" isOpen={this.state.popover} target={this.props.name} toggle={this.toggle}>
          <SketchPicker color={this.props.value} disableAlpha={true} width={200} onChangeComplete={(color) => {
            this.setState({popover: false});
            this.props.onChange(color);
          }} />
        </Popover>
      </div>
    );
  }
}

class ColorPicker extends Component {

  state = {
    popover: false
  };

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      popover: !this.state.popover
    });
  }

  render() {

    return (
      <div className="t-generic-color-picker">
        <button id={this.props.name} className="btn btn-block" onClick={this.toggle}>
          <span className="color-sample" style={{backgroundColor: this.props.value}} />
          {this.props.value}
        </button>
        <CirclePicker color={this.props.value} onChangeComplete={this.props.onChange} width={220} circleSize={28} circleSpacing={8}
                      colors={[
                        "#ffffff", "#ff0000", "#000000", "#ffb9eb", "#623219", "#DCDCDC",
                        "#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3",
                        "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39",
                        "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b"
                      ]}/>
        <Popover placement="bottom" isOpen={this.state.popover} target={this.props.name} toggle={this.toggle}>
          <SketchPicker color={this.props.value} disableAlpha={true} width={200} onChangeComplete={this.props.onChange} />
        </Popover>
      </div>
    );
  }
}

export default ColorPicker;


// WEBPACK FOOTER //
// ./src/components/ColorPicker.js